module.exports = __webpack_public_path__ + "static/media/miscData.4a2a9482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/miscData.jpg
// module id = 404
// module chunks = 0